import eventTypeService from '@/api/eventModule/eventTypeServices'

export default {
  loadTable({ commit }, pageConfig) {
    return new Promise((resolve, reject) => eventTypeService
      .loadTable(pageConfig)
      .then(result => {
        commit('LOAD_LIST_EVENT_TYPES', result.data.content)
        resolve(result)
      })
      .catch(err => reject(err)))
  },
  insertNewEventType({ commit }, data) {
    return eventTypeService
      .insertNewEventType(data)
      .then(result => result)
      .catch(error => error)
  },
  prepareToEditEventType({ commit }, data) {
    commit('PREPARE_TO_EDIT_EVENT_TYPE', data)
  },
  editEventType({ commit }, data) {
    return eventTypeService
      .editEventType(data)
      .then(result => result)
      .catch(error => error)
  },
  resetEventType({ commit }) {
    commit('RESET_EVENT_TYPE')
  },
  delete({ commit }, id) {
    return eventTypeService
      .deleteEventType(id)
      .then(result => result)
      .catch(error => error)
  },
}
